import { COUNTRIES } from "@/lib/countries";

export const CountrySelect = ({ value, onChange, testId, className = "" }) => (
  <select data-testid={testId} value={value || ""} onChange={(e) => onChange(e.target.value)}
    className={`rounded-xl border border-slate-300 bg-white px-3 text-sm outline-none focus:border-slate-500 transition-colors ${className}`}>
    <option value="">Select country…</option>
    {COUNTRIES.map((c) => <option key={c} value={c}>{c}</option>)}
  </select>
);
